import { UseCubeQueryResult } from '@cubejs-client/react';
import { Box, Typography } from '@mui/material';
import { formatNumber, NumberFormatPreset } from '@procureai/ui-mui';
import { Union } from 'ts-toolbelt';

import { CubeChart, CubeChartType } from '~/components/CubeChart';
import { monthsInYearFormatter } from '~/components/CubeChart/CubeChart.common';
import { PlaceholderWidget } from '~/components/PlaceholderWidget/PlaceholderWidget';

interface MonthlyBarChartProps {
  queryResult: UseCubeQueryResult<any, any>;
  caption?: Union.Nullable<string>;
}

export const MonthlyBarChart = ({ queryResult, caption }: MonthlyBarChartProps) => {
  if (!queryResult) {
    return <PlaceholderWidget />;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flex: '1 1 0',
        alignItems: 'flex-end',
      }}
    >
      <Box
        sx={{
          flex: '1 1 0',
          display: 'flex',
          mb: '-5px',
          mr: 3,
        }}
      >
        {caption && (
          <Typography component="div" variant="caption" color="textPrimary">
            {caption}
          </Typography>
        )}
      </Box>
      <CubeChart
        type={CubeChartType.tinyBar}
        formatter={{
          x: monthsInYearFormatter,
          y: formatNumber(NumberFormatPreset.INTEGER_COMPACT),
        }}
        {...queryResult}
      />
    </Box>
  );
};
